<template>
    <div class="container">
        <div class="row">
            <div class="col">
                <div class="input-group input-group-lg">
                    <input type="text" class="form-control mb-2 text-end" v-model="AmountText" readonly>
                </div>
            </div>
        </div>
        <div class="row px-2">
            <div class="col bg-light px-1 pb-1">
            <button type="button" class="btn btn-outline-success" style="width:100%;" @click="buttonNumberPressed(7)">7</button>
            </div>
            <div class="col bg-light px-1">
            <button type="button" class="btn btn-outline-success" style="width:100%;" @click="buttonNumberPressed(8)">8</button>
            </div>
            <div class="col bg-light px-1">
            <button type="button" class="btn btn-outline-success" style="width:100%;" @click="buttonNumberPressed(9)">9</button>
            </div>
            <div class="col bg-light px-1">
            <button type="button" class="btn btn-secondary" style="width:100%;" @click="buttonBackPressed()">Back</button>
            </div>
        </div>
        <div class="row px-2">
            <div class="col bg-light px-1  pb-1">
            <button type="button" class="btn btn-outline-success" style="width:100%;" @click="buttonNumberPressed(4)">4</button>
            </div>
            <div class="col bg-light px-1 ">
            <button type="button" class="btn btn-outline-success" style="width:100%;" @click="buttonNumberPressed(5)">5</button>
            </div>
            <div class="col bg-light px-1 ">
            <button type="button" class="btn btn-outline-success" style="width:100%;" @click="buttonNumberPressed(6)">6</button>
            </div>
            <div class="col bg-light px-1 ">
            <button type="button" class="btn btn-outline-danger" style="width:100%;" @click="buttonACPressed()">AC</button>
            <!-- <button type="button" class="btn btn-secondary" style="width:100%;">-</button> -->
            </div>
        </div>
        <div class="row px-2">
            <div class="col bg-light px-1  pb-1">
            <button type="button" class="btn btn-outline-success" style="width:100%;" @click="buttonNumberPressed(1)">1</button>
            </div>
            <div class="col bg-light px-1 ">
            <button type="button" class="btn btn-outline-success" style="width:100%;" @click="buttonNumberPressed(2)">2</button>
            </div>
            <div class="col bg-light px-1 ">
            <button type="button" class="btn btn-outline-success" style="width:100%;" @click="buttonNumberPressed(3)">3</button>
            </div>
            <div class="col bg-light px-1 ">
            <!-- <button type="button" class="btn btn-secondary" style="width:100%;">+</button> -->
            </div>
        </div>
        <div class="row px-2">
            <div class="col bg-light px-1  pb-1">
            <button type="button" class="btn btn-outline-success" style="width:100%;" @click="buttonNumberPressed('00')">00</button>
            </div>
            <div class="col bg-light px-1 ">
            <button type="button" class="btn btn-outline-success" style="width:100%;" @click="buttonNumberPressed(0)">0</button>
            </div>
            <div class="col bg-light px-1 ">
            <button type="button" class="btn btn-outline-secondary" style="width:100%;" @click="buttonDotPressed()" title="จุดทศนิยม"> <b>.</b></button>
            </div>
            <div class="col bg-light px-1 ">
            <button type="button" class="btn btn-primary" style="width:100%;" @click="buttonOKPressed()">OK</button>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: 'TomNumpad',
  components: {

  },
  data () {
    return {
      // NumPad
      Amount: 0,
      AmountText: ''
    }
  },
  mounted () {

  },
  methods: {
    buttonOKPressed () {
      this.$emit('onNumpadOKEvent', this.Amount)
      this.buttonACPressed()
    },
    buttonACPressed () {
      this.AmountText = '0'
      this.Amount = parseFloat(this.AmountText)
    },
    buttonNumberPressed (CaptionBtn) {
      if (this.AmountText.length >= 12) {
        return
      }
      if (CaptionBtn >= 0 && CaptionBtn <= 9) {
        this.AmountText = this.AmountText + CaptionBtn
        this.Amount = parseFloat(this.AmountText)
      } else if (CaptionBtn === '00') {
        this.AmountText = this.AmountText + CaptionBtn
        this.Amount = parseFloat(this.AmountText)
      }
      if (this.AmountText.indexOf('.') < 0) {
        this.AmountText = this.Amount.toString()
      }
    },
    buttonDotPressed () {
      if (this.AmountText.length >= 12) {
        return
      }
      if (this.AmountText.indexOf('.') >= 0) {
        return
      }
      this.AmountText = this.AmountText + '.'
      this.Amount = parseFloat(this.AmountText)
    },
    buttonBackPressed () {
      if (this.AmountText.length > 1) {
        this.AmountText = this.AmountText.substring(0, this.AmountText.length - 1)
        this.Amount = parseFloat(this.AmountText)
      } else {
        this.AmountText = '0'
        this.Amount = parseFloat(this.AmountText)
      }
    }
  }
}
</script>

<style>

</style>
